
























import { Component, Prop, Vue } from "vue-property-decorator";
import { Client, Event } from "@leancloud/play";
import { errorHandler, listen } from "../utils";
import { configs } from "../configs";

@Component
export default class Login extends Vue {
  id = Date.now().toString();
  configs = configs;

  @Prop() private onLogin!: (client: Client) => any;

  login() {
    const client = new Client({
      appId: configs.appId,
      appKey: configs.appKey,
      playServer: configs.playServer,
      userId: this.id,
    });

    client
      .connect()
      .then(() => this.onLogin(client))
      .catch(errorHandler);
  }
}
